<script setup lang="ts">
const logoUrl = 'https://opticacroma.com.ar/wp-content/uploads/2024/05/croma-logo-1-e1715382202765.png';
</script>

<template>
  <header class="bg-white shadow-sm mb-6">
    <div class="container mx-auto px-6 py-4">
      <div class="grid grid-cols-3 items-center">
        <!-- Logo on the left -->
        <div class="flex items-center">
          <img 
            :src="logoUrl" 
            alt="Óptica Croma Logo" 
            class="h-12 w-auto"
          />
        </div>
        <div class="flex justify-center">
        <!-- Title in center -->
        <h1 class="text-3xl font-bold text-slate-800 text-center">
          Lista de Precios
        </h1>
        </div>
        <!-- Actions on the right -->
        <div class="flex justify-end">
          <slot></slot>
        </div>
      </div>
    </div>
  </header>
</template>


Los cambios realizados incluyen:

1. Uso de CSS Grid para dividir el header en tres columnas:
   - Columna izquierda: Logo
   - Columna central: Título
   - Columna derecha: Acciones (botones de modo admin/público)

2. Centrado del título usando `text-center`

3. Mantenimiento del espacio y alineación correcta de todos los elementos

El título "Lista de Precios" ahora aparecerá centrado en el header, mientras que el logo se mantiene a la izquierda y los botones de acción